import {AgentCode} from './AgentCode.enum';
import {Display} from './requestContext/Display.interface';

export function getAgentCode({isWebView, isMobile}: Display) {
  return isWebView
    ? AgentCode.App
    : isMobile
      ? AgentCode.MobileWeb
      : AgentCode.PcWeb;
}
